import { cn } from 'corso-admin-ui';
import { forwardRef, PropsWithChildren } from 'react';

export const List = forwardRef<
  HTMLUListElement,
  PropsWithChildren<{ className?: string }>
>(({ className, children }, ref) => (
  <ul className={cn('grid gap-px bg-neutral-200', className)} ref={ref}>
    {children}
  </ul>
));

export const ListItem = forwardRef<
  HTMLLIElement,
  PropsWithChildren<{ className?: string }>
>(({ className, children }, ref) => (
  <li className={cn('bg-white', className)} ref={ref}>
    {children}
  </li>
));
